module.exports = __webpack_public_path__ + "static/media/Urgently.e914adb3.svg";